import { SvgIcon } from '@mui/material'
import * as React from 'react'

function MoreHoriz(props, ref) {
  return (
    <SvgIcon
      className='more-horiz-icon'
      viewBox='0 0 24 24'
      {...props}
      ref={ref}
    >
      <path d='M0 0h24v24H0z' fill='none' />
      <path d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' />
    </SvgIcon>
  )
}

const MemoMoreHoriz = React.memo(React.forwardRef(MoreHoriz))

export default MemoMoreHoriz
